import { SystemStyleObject } from "@chakra-ui/react";

export const filterHeaderWrapperCss: SystemStyleObject = {
  padding: "10px 16px",
  height: "46px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid #F2F4F7",
};
